import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaGforRequest } from './types';

// ACTIONS
import { consultaGforSuccess, consultaGforFailure } from './actions';

function* consultaGfor(request: ReducerAction) {
	const { payload }: { payload: ConsultaGforRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/pesquisa/gfor`,
		payload,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(consultaGforSuccess(response));
	} else {
		yield put(consultaGforFailure(response));
	}
}

export default all([takeLatest(Types.CONSULTA_GFOR_REQUEST, consultaGfor)]);
